<template>
  <Button
    class="OfferCardAction"
    v-bind="$attrs"
    size="extra-small"
    @click.stop="$emit('click')"
  >
    <slot />
  </Button>
</template>

<script>
import Button from '~/aasgard/components/buttons/Button.vue'
export default {
  name: 'OfferCardAction',
  components: {
    Button,
  },
  emits: ['click'],
  // check Button.vue for the Button component
}
</script>

<style lang="scss"></style>
